import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Equipement = () => {
  const sectorData = {
    title: "Équipement",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les fournisseurs d'équipements industriels, médicaux ou de bureau doivent adresser des cycles longs, des appels d'offres formalisés et plusieurs décideurs. Proposer des fiches produits optimisées, des simulateurs de coûts et du contenu métier aide à qualifier les prospects et structurer la prospection.",
    name: "Équipement",
    titleContext: "des équipementiers",
    responseContext: "des équipementiers",
    expertContext: "du secteur de l'équipement"
  };

  return <SectorPage sector={sectorData} />;
};

export default Equipement; 